<template>
  <div>
    <div class="imessage">
      <template v-for="message in messages">
        <div class="message-info">
          <p class="from-name">{{ message.me ? "Me" : message.name }}</p>
          <p class="from-time">{{ message.timestamp }}</p>
        </div>
        <div class="message-box" style="display: flex;">
          <div v-if="message.profile_image_location" class="profile-picture-container">
            <i v-if="message.user_group_id===7" class="fa-solid fa-2xl fa-user-shield police-icon"></i>
            <img v-else src="../../assets/images/default_user_image.jpg" height="50"/>
          </div>
          <p v-bind:class="[message.me ? 'from-me' : 'from-them']">{{ message.message }}</p>
        </div>
      </template>
    </div>
    <div id="send-message-container" class="form-group form-inline">
      <input  @keyup.enter="sendMessage" type="text" class="form-control" v-model="message"></input>
      <!-- works when you press enter -->
      <button @click="sendMessage" class="btn btn-primary"><i class="fa fa-paper-plane"></i></button>
    </div>
  </div>
</template>

<script type="text">
import { mapGetters } from 'vuex'
import moment from 'moment'
const CHAT_DATE_FORMAT = 'h:mm a'

export default {
  name: 'Chat',
  components: {},
  sockets: {
    chatmessage: function (data) {
      console.log("received message: ")
      console.log(data)
      this.messages.push(
        {
          'me': false,
          'name': data['name'],
          'message': data['message'],
          'timestamp': moment(data['timestamp']*1000).format(CHAT_DATE_FORMAT),
          'user_group_id': data['user_group_id'],
          'profile_image_location': data['profile_image_location']
        }
      )
    }
  },
  methods: {
    sendMessage (e) {
      e.preventDefault()

      if (this.message.trim().length === 0) {
        return
      }

      const now = moment().format(CHAT_DATE_FORMAT)
      this.$socket.client.emit('sendchatmessage', this.message)
      this.messages.push(
        {
          'me': true,
          'name': null,
          'message': this.message,
          'timestamp': now,
          'user_group_id': this.user_group_id,
          'profile_image_location': this.profile_image_location
        }
      )
      this.message = ''
    }
  },
  computed: {
    ...mapGetters({
      messages: 'getChatMessages'
    }),
    profile_image_location: function () {
      let parsedJSON = JSON.parse(sessionStorage.getItem('logged_in_data'))
      return parsedJSON.profile_image_location
    },
    user_group_id: function () {
      let parsedJSON = JSON.parse(sessionStorage.getItem('logged_in_data'))
      return parsedJSON.logged_in_user.group.group_id
    }
  },
  data () {
    return {
      message: ''
    }
  },
  watch: {
  },
  updated () {
    const chatWindow = document.getElementsByClassName('imessage')[0] 
    var xH = chatWindow.scrollHeight; 
    chatWindow.scrollTo(0, xH);
  },
  mounted () {
    this.$store.dispatch('getChatMessages')
    // Open the socket connection
    this.$socket.client.io.opts.extraHeaders = {
      Authorization: 'Bearer ' + $cookies.get('jwt')
    }
    this.$socket.client.open();
  },
  beforeDestroy () {
    this.$socket.client.close();
  }
}
</script>

<style scoped>
.imessage {
  background-color: #fff;
  border: 1px solid #e5e5ea;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  max-width: 600px;
  padding: 0.5rem 1.0rem;
  min-height: 600px;
  max-height: 600px;
  overflow-y: scroll;
  overflow-block: auto;
}

.message-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.imessage p.from-me, .imessage p.from-them {
  border-radius: 0.15rem;
  line-height: 1.25;
  padding: 0.5rem .875rem;
  position: relative;
  word-wrap: break-word;
}

.imessage p.from-name, .imessage p.from-time {
  margin: 0; 
  font-size: .8rem;
  color: #999;
}
p.from-me {
  background-color: #96d600;
  color: #fff;
}

p.from-them {
  align-items: flex-start;
  background-color: #e5e5ea;
  color: #000;
}

p.from-them ~ p.from-me {
  min-height:40px;
  font-size: 1rem;
}

p[class^="from-"] .profile-picture {
  margin: 0.5rem 0;
}

.profile-picture-container {
  width: 50px;
  height: 50px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-picture {
  margin-right: 10px;
}

.police-icon {
  color: #0E4399;
}

p.from-me ~ p.from-me {
  margin: 0.25rem 0 0;
}

p.from-me ~ p.from-me:not(:last-child) {
  margin: 0.25rem 0 0;
}

p.from-me ~ p.from-me:last-child {
  margin-bottom: 0.5rem;
}

#send-message-container {
  border: 1px solid #e5e5ea;
  width: 100%;
  max-width: 600px;
  display: flex;
}

#send-message-container input {
  border: none;
  flex: 1;
}

#send-message-container button {
  background-color: #003466;
  border: 1px solid #003466;
}

</style>
